export default function (md) {
  md.inline.ruler.before('text', 'citation', function (state, silent) {
    var str = state.src.slice(state.pos);

    /**
     * Matches the following:
     * [^00^]
     */
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var citationRegexp = /^\[\^[^\^]+\^]/;
    var match = citationRegexp.exec(str);
    if (!match) {
      return false;
    }
    if (silent) {
      return true;
    }

    // Just skip citation from parsing and don't render them in the output.
    state.pos += match[0].length;
    return true;
  });
}